
import { useState, useEffect } from 'react';
import { useTheme } from '../../context/ThemeContext';
import { Moon, Sun } from 'lucide-react';

export const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  // Ensure this component only renders client-side
  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;

  return (
    <button
      onClick={toggleTheme}
      className="relative flex h-9 w-9 items-center justify-center rounded-full transition-colors
                hover:bg-gray-100 dark:hover:bg-gray-800 focus:outline-none"
      aria-label={theme === 'light' ? 'Switch to dark theme' : 'Switch to light theme'}
    >
      <div className="relative overflow-hidden rounded-full">
        <Sun 
          className={`h-5 w-5 transition-all duration-500 ease-in-out ${
            theme === 'dark' ? 'rotate-90 opacity-0 scale-0' : 'rotate-0 opacity-100 scale-100'
          }`} 
        />
        <Moon 
          className={`absolute top-0 h-5 w-5 transition-all duration-500 ease-in-out ${
            theme === 'light' ? '-rotate-90 opacity-0 scale-0' : 'rotate-0 opacity-100 scale-100'
          }`} 
        />
      </div>
    </button>
  );
};
